import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-investment-creation-grid',
  templateUrl: './investment-creation-grid.component.html',
  styleUrls: ['./investment-creation-grid.component.css']
})
export class InvestmentCreationGridComponent implements OnInit {
  title="Investment List"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/investment/investment-creation-grid/investment-creation-grid.component.ts